export default {
    inheritAttrs: false,
}
